/*
 *  This file environment.main.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2023
 *  (C) 2015-2023. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

export const environment = {
  production: false,
  envName: "production",
  domainCode: "hronenew-testing",
  base_url: "https://test.hrone.work",
  isDeployOnGT: false,
  isGDPRPointerEnabled: true,
  isWhatsappOTPEnabled: true,
  microservice_base_url:"https://gateway.test.hrone.work",
  allowedPaymentRedirectHosts: ['smartgateway.hdfcuat.bank.in', "smartgateway.hdfc.bank.in"],
};